import React from "react";
import styled from "styled-components";

const SvgContainer = styled.svg<SpacecloudProps>`
  position: fixed;
  bottom: -5%;
  left: 35%;
  overflow: visible;
  transform: ${(props) => {
    return props.isLoading === false ? "translateY(0%)" : "translateY(60%)";
  }};
  transition: 2.5s;

  @media only screen and (max-width: 768px) {
    bottom: 0%;
  }
`;

interface SpacecloudProps {
  isLoading: boolean;
}

const Spacecloud: React.FC<SpacecloudProps> = (props) => {
  return (
    <SvgContainer
      isLoading={props.isLoading}
      width="1440"
      height="301"
      viewBox="0 0 1440 301"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M181 265.91C181 320.31 136.9 364.41 82.5 364.41C28.1 364.41 -16 320.31 -16 265.91C-16 211.51 28.1 167.41 82.5 167.41C136.9 167.41 181 211.51 181 265.91Z"
        fill="#113352"
      />
      <path
        d="M380 313.41C380 368.086 335.452 412.41 280.5 412.41C225.548 412.41 181 368.086 181 313.41C181 258.734 225.548 214.41 280.5 214.41C335.452 214.41 380 258.734 380 313.41Z"
        fill="#113352"
      />
      <path
        d="M733 144.91C733 183.294 701.884 214.41 663.5 214.41C625.116 214.41 594 183.294 594 144.91C594 106.526 625.116 75.41 663.5 75.41C701.884 75.41 733 106.526 733 144.91Z"
        fill="#113352"
      />
      <path
        d="M855 156.91C855 195.294 823.884 226.41 785.5 226.41C747.116 226.41 716 195.294 716 156.91C716 118.526 747.116 87.41 785.5 87.41C823.884 87.41 855 118.526 855 156.91Z"
        fill="#113352"
      />
      <path
        d="M902 108.91C902 134.591 881.181 155.41 855.5 155.41C829.819 155.41 809 134.591 809 108.91C809 83.2288 829.819 62.41 855.5 62.41C881.181 62.41 902 83.2288 902 108.91Z"
        fill="#113352"
      />
      <path
        d="M1077 64.91C1077 90.5912 1056.18 111.41 1030.5 111.41C1004.82 111.41 984 90.5912 984 64.91C984 39.2288 1004.82 18.41 1030.5 18.41C1056.18 18.41 1077 39.2288 1077 64.91Z"
        fill="#113352"
      />
      <path
        d="M1348.57 125.356C1343.95 153.702 1317.01 172.904 1288.39 168.245C1259.77 163.586 1240.32 136.83 1244.93 108.484C1249.54 80.1387 1276.49 60.9369 1305.1 65.5959C1333.72 70.2549 1353.18 97.0105 1348.57 125.356Z"
        fill="#113352"
      />
      <path
        d="M1488.57 130.419C1483.91 159.037 1456.94 178.459 1428.32 173.8C1399.7 169.141 1380.28 142.165 1384.94 113.547C1389.6 84.9285 1416.57 65.5058 1445.19 70.1648C1473.81 74.8238 1493.23 101.8 1488.57 130.419Z"
        fill="#113352"
      />
      <path
        d="M1402.31 143.731C1399.25 162.537 1381.52 175.301 1362.72 172.239C1343.91 169.177 1331.15 151.45 1334.21 132.644C1337.27 113.838 1355 101.074 1373.8 104.136C1392.61 107.197 1405.37 124.925 1402.31 143.731Z"
        fill="#113352"
      />
      <path
        d="M1018 86.41C1018 124.518 986.66 155.41 948 155.41C909.34 155.41 878 124.518 878 86.41C878 48.3024 909.34 17.41 948 17.41C986.66 17.41 1018 48.3024 1018 86.41Z"
        fill="#113352"
      />
      <path
        d="M1284.76 75.4543C1278.99 110.886 1245.59 134.934 1210.16 129.165C1174.72 123.397 1150.68 89.9974 1156.44 54.5654C1162.21 19.1333 1195.61 -4.91385 1231.04 0.854462C1266.48 6.62277 1290.52 40.0222 1284.76 75.4543Z"
        fill="#113352"
      />
      <path
        d="M617 185.91C617 208.278 599.091 226.41 577 226.41C554.909 226.41 537 208.278 537 185.91C537 163.542 554.909 145.41 577 145.41C599.091 145.41 617 163.542 617 185.91Z"
        fill="#113352"
      />
      <path
        d="M223 271.91C223 294.278 204.644 312.41 182 312.41C159.356 312.41 141 294.278 141 271.91C141 249.542 159.356 231.41 182 231.41C204.644 231.41 223 249.542 223 271.91Z"
        fill="#113352"
      />
      <path
        d="M437 271.91C437 294.278 418.868 312.41 396.5 312.41C374.132 312.41 356 294.278 356 271.91C356 249.542 374.132 231.41 396.5 231.41C418.868 231.41 437 249.542 437 271.91Z"
        fill="#113352"
      />
      <path
        d="M494 271.91C494 294.278 476.091 312.41 454 312.41C431.909 312.41 414 294.278 414 271.91C414 249.542 431.909 231.41 454 231.41C476.091 231.41 494 249.542 494 271.91Z"
        fill="#113352"
      />
      <path
        d="M591.574 234.682C601.377 259.074 585.235 288.529 555.519 300.472C525.804 312.414 493.767 302.321 483.964 277.929C474.161 253.536 490.304 224.081 520.019 212.139C549.735 200.196 581.771 210.289 591.574 234.682Z"
        fill="#113352"
      />
      <path
        d="M402.5 280.41L39 243.91V306.91H1485L1477 123.41H1447.5C1438 123.41 1422 123.41 1396.5 128.91C1371 134.41 1362.5 135.91 1314 123.41C1265.5 110.91 1281 112.41 1261 99.41C1241 86.41 1198 61.91 1185 57.41C1172 52.91 1131 51.91 1104.5 49.91C1078 47.91 985 98.41 966.5 99.41C948 100.41 915.5 114.91 884.5 122.41C853.5 129.91 805.5 145.91 776.5 146.91C753.3 147.71 682.5 160.91 650 167.41C630.833 177.41 591.4 197.91 587 199.91C581.5 202.41 506.5 263.91 500 263.91C494.8 263.91 432.833 274.91 402.5 280.41Z"
        fill="#113352"
      />
    </SvgContainer>
  );
};

export default Spacecloud;
